
import { defineComponent } from 'vue'
import { setI18nLanguage } from '@/i18n'
import { LanguagesType } from '@/types'
import { constants } from '@/constants'
import AsahiLogoNew from '@/components/library/assets/AsahiLogoNew.vue'
import AsahiLanguageSelector from '@/components/library/AsahiLanguageSelector.vue'
import AsahiTypography from '@/components/library/Typography.vue'

export default defineComponent({
  name: 'BeforeLoginLayout',
  components: {
    AsahiLanguageSelector,
    AsahiLogoNew,
    AsahiTypography
  },
  data: () => ({
    activeLanguage: (localStorage.getItem('lang')) as LanguagesType,
    theme: constants.application.theme
  }),

  inject: ['isPeroni'],

  computed: {
    user () {
      return this.$store.state.auth.user
    },

    languages () {
      return ['hu', 'en']
    }
  },
  mounted () {
    if (localStorage?.getItem('lang') === 'null') {
      this.activeLanguage = this.languages[0] as LanguagesType
    } else {
      this.activeLanguage = (localStorage?.getItem('lang') || this.languages[0]) as LanguagesType
    }
    setI18nLanguage(this.activeLanguage)
  },

  methods: {
    changeLanguage (langCode: LanguagesType) {
      this.activeLanguage = langCode
      setI18nLanguage(langCode)
    }
  }
})
